import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BodyClassUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const classMap = {
      "/livestream/meeting": "meetingScreen",
      "/livestream/start": "device-setting",
    };

    document.body.classList.remove("meetingScreen", "device-setting");

    if (classMap[location.pathname]) {
      document.body.classList.add(classMap[location.pathname]);
    }

    return () => {
      document.body.classList.remove("meetingScreen", "device-setting");
    };
  }, [location.pathname]);

  return null;
};

export default BodyClassUpdater;